import { useParams, Navigate } from "react-router-dom";

const RedirectOldToNew = () => {
  const { slug } = useParams();
  return <Navigate to={`/product/${slug}`} replace />;
};

export default RedirectOldToNew;
